import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const jsonLdOrganization = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '女性健康指南',
  url: 'https://readdy.ai',
  description: '专注于女性生殖健康科普的知识平台，提供专业、易懂的女性生殖系统知识。',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-123-4567',
    contactType: 'customer service',
    availableLanguage: ['Chinese'],
  },
};

const jsonLdWebSite = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '女性健康指南',
  url: 'https://readdy.ai',
  description: '全面解析女性生殖系统的解剖结构、生理功能与常见健康问题。',
  inLanguage: 'zh-CN',
};

const jsonLdFAQ = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    { '@type': 'Question', name: '月经周期多少天算正常？', acceptedAnswer: { '@type': 'Answer', text: '正常月经周期为21-35天，平均28天。周期长度因人而异，只要规律且在正常范围内即为正常。偶尔的周期变化无需过度担忧。如果周期持续不规律，建议咨询妇科医生。' } },
    { '@type': 'Question', name: '多大年龄开始做宫颈癌筛查？', acceptedAnswer: { '@type': 'Answer', text: '根据国内外指南建议，25岁开始进行宫颈癌筛查。25-29岁可每3年做一次TCT；30-65岁建议每3-5年进行TCT和HPV联合筛查。' } },
    { '@type': 'Question', name: '痛经正常吗？什么时候需要就医？', acceptedAnswer: { '@type': 'Answer', text: '原发性痛经在年轻女性中很常见。但如果痛经逐渐加重、影响正常工作生活、止痛药效果不佳，或伴有月经量异常增多、非经期疼痛等症状，需及时就医。' } },
    { '@type': 'Question', name: '白带什么样算正常？', acceptedAnswer: { '@type': 'Answer', text: '正常白带呈白色或透明、无异味，量随月经周期变化。若出现黄绿色、泡沫状、豆腐渣样白带，或伴有异味、外阴瘙痒灼痛等不适，提示可能有感染。' } },
    { '@type': 'Question', name: '卵巢早衰可以预防吗？', acceptedAnswer: { '@type': 'Answer', text: '卵巢早衰指40岁前卵巢功能衰竭。可通过避免盆腔手术损伤、戒烟、保持健康体重、避免接触环境内分泌干扰物等方式保护卵巢功能。' } },
    { '@type': 'Question', name: 'HPV疫苗多大年龄接种有效？', acceptedAnswer: { '@type': 'Answer', text: 'HPV疫苗推荐接种年龄为9-45岁，最佳接种年龄为9-14岁。已有性生活的女性仍可从接种中获益。' } },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdOrganization) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdWebSite) }} />
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLdFAQ) }} />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <CategoryNav />
          <FeaturedArticles />
          <FAQSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}